export default __webpack_public_path__ + "static/media/477.6a0d1c16.png";